import { PAYABLE_REVIEW_NAMESPACE } from "constants/i18n-namespaces";
import { Tooltip, TooltipEnums } from "kubra-ux-forge";
import React from "react";
import { useTranslation } from "react-i18next";
import { ICharityState } from "types/charity";
import { IPayableSessionData } from "types/payableSession";

interface FeesAndTotalProps {
  selectedCharities?: ICharityState[];
  payableSession: IPayableSessionData;
  currencyFormatter: {
    format: (amount: number) => string;
  };
}

export const FeesAndTotal: React.FC<FeesAndTotalProps> = ({
  selectedCharities,
  payableSession,
  currencyFormatter,
}) => {
  const { t } = useTranslation(PAYABLE_REVIEW_NAMESPACE);
  const feeAmount = payableSession?.payableItemResponse?.fee?.amount ?? 0;
  const totalAmount =
    payableSession?.payableItemResponse?.itemAndFeeTotalAmount;
  return (
    <>
      {selectedCharities != undefined &&
        selectedCharities.length > 0 &&
        selectedCharities.map(
          (charityState: ICharityState) =>
            charityState.selected &&
            charityState.amount > 0 && (
              <div
                className="ez-pay-summary-field-item"
                data-cy={`ez-pay-summary-field-item-donation-${charityState.charity.code}-value`}
                key={charityState.charity.code}
              >
                <dt data-cy="ez-pay-summary-field-item-donation-to-label">
                  {t("donation-to", { name: charityState.charity.name })}
                </dt>
                <dd data-cy="ez-pay-summary-field-item-donation-value">
                  {currencyFormatter.format(charityState.amount)}
                </dd>
              </div>
            ),
        )}

      {feeAmount > 0 && (
        <div
          className="ez-pay-summary-field-item"
          data-cy="ez-pay-summary-field-item-service-fee"
        >
          <dt data-cy="ez-pay-summary-field-item-service-fee-label">
            {t("service-fee")}&nbsp;
            <Tooltip
              direction={TooltipEnums.TopRight}
              content={t("service-fee-tooltip")}
              data-cy="service-fee-tooltip"
              variant="rich"
            />
          </dt>
          <dd data-cy="ez-pay-summary-field-item-service-fee-value">
            {currencyFormatter.format(feeAmount)}
          </dd>
        </div>
      )}

      {totalAmount != null && (
        <div
          className="ez-pay-summary-field-item payment-total"
          data-cy="ez-pay-field-item-payment-total"
        >
          <dt data-cy="ez-pay-summary-field-item-payment-total-label">
            {t("payment-total")}
          </dt>
          <dd data-cy="ez-pay-summary-field-item-payment-total-value">
            {currencyFormatter.format(totalAmount)}
          </dd>
        </div>
      )}
    </>
  );
};
